import { useState } from 'react'

export default function InputPassword (props = {}) {
    const { type, className, ...renderProps } = props

    const [visible, setVisible] = useState(false)

    const onVisiblityToggle = (e) => {
        if (e.type === 'keydown'
                && !e.key.match(/^(enter|\s)$/i))
            return

        e.preventDefault()
        e.stopPropagation()

        setVisible(!visible)
    }

    return (
        <>
            <input
                type={visible
                    ? 'text'
                    : 'password'}
                className={`input-password ${className || ''}`
                    .trim()}
                {...renderProps}
            />
            <a
                className="input-password-visibility-toggle"
                aria-label={`${visible
                    ? 'Hide'
                    : 'Show'} password`}
                role="button"
                tabIndex="0"
                onClick={onVisiblityToggle}
                onKeyDown={onVisiblityToggle}
            >
                <svg
                    className="icon-visibility"
                    width="18"
                    height="18"
                    style={{
                        opacity: visible
                            ? 0
                            : 1
                    }}
                >
                    <use xlinkHref="#icon-visibility" />
                </svg>
                <svg
                    className="icon-visibility"
                    width="18"
                    height="18"
                    style={{
                        opacity: !visible
                            ? 0
                            : 1
                    }}
                >
                    <use xlinkHref="#icon-visibility-off" />
                </svg>
            </a>
        </>
    )
}
